<script setup lang="ts">
  // Replaces the desktop wizard's Paper step: paper width doesn't exist
  // natively — what matters is the print LANGUAGE. Wizard-local only; drives
  // the test format and the Assign step's destination filtering. This is the
  // structural kill of the "Zebra trap" (ESC/POS silently swallowed by
  // ZPL-only printers).
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';

  export type TNativeWizardType = 'escpos' | 'zpl';

  const emit = defineEmits<{
    (e: 'select', type: TNativeWizardType): void;
  }>();

  const options: {
    value: TNativeWizardType;
    icon: string;
    titleKey: string;
    descKey: string;
  }[] = [
    {
      value: 'escpos',
      icon: 'receipt',
      titleKey: 'printingV2.nativeTypeEscposTitle',
      descKey: 'printingV2.nativeTypeEscposDesc',
    },
    {
      value: 'zpl',
      icon: 'tag-outline',
      titleKey: 'printingV2.nativeTypeZplTitle',
      descKey: 'printingV2.nativeTypeZplDesc',
    },
  ];
</script>

<template>
  <div class="native-step-type">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="type-card"
      @click="emit('select', option.value)"
    >
      <div class="type-card-icon">
        <PosUiIcon :name="option.icon" :size="26" />
      </div>
      <div class="type-card-title">{{ $t(option.titleKey) }}</div>
      <div class="type-card-desc">{{ $t(option.descKey) }}</div>
    </button>
  </div>
</template>

<style scoped lang="scss">
  .native-step-type {
    @apply tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-2;

    .type-card {
      @apply tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-neutral-200 tw-bg-white tw-px-4 tw-py-6 tw-text-center tw-transition-colors hover:tw-border-orange-300 hover:tw-bg-orange-50/40;

      .type-card-icon {
        @apply tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-xl tw-bg-neutral-100 tw-text-neutral-500;
      }

      .type-card-title {
        @apply tw-text-sm tw-font-semibold tw-text-neutral-900;
      }

      .type-card-desc {
        @apply tw-text-xs tw-text-neutral-500;
      }
    }
  }
</style>
